var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2864 8.33203H5.71494C5.08347 8.33203 4.47786 8.57786 4.03135 9.01545C3.58483 9.45303 3.33398 10.0465 3.33398 10.6654V29.332C3.33398 29.9509 3.58483 30.5444 4.03135 30.9819C4.47786 31.4195 5.08347 31.6654 5.71494 31.6654H34.2864C34.9178 31.6654 35.5234 31.4195 35.97 30.9819C36.4165 30.5444 36.6673 29.9509 36.6673 29.332V10.6654C36.6673 10.0465 36.4165 9.45303 35.97 9.01545C35.5234 8.57786 34.9178 8.33203 34.2864 8.33203ZM31.6673 10.6654L20.0007 18.5754L8.33398 10.6654H31.6673ZM5.71494 29.332V11.727L19.3221 20.9554C19.5214 21.0908 19.7581 21.1634 20.0007 21.1634C20.2432 21.1634 20.4799 21.0908 20.6792 20.9554L34.2864 11.727V29.332H5.71494Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.92eaaf0557b377dbf93bb9da389e3384.svg";
export { ForwardRef as ReactComponent };